import { render, staticRenderFns } from "./BlocTabs.vue?vue&type=template&id=ff906432&"
import script from "./BlocTabs.vue?vue&type=script&lang=js&"
export * from "./BlocTabs.vue?vue&type=script&lang=js&"
import style0 from "./BlocTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports